import axios from 'axios';
import { ApiHistoryResponse } from '@/rennovation/planning-view/types/api/history-response';

interface HistoryPayload {
	model: 'Duty' | string;
	id?: string;
	user?: string;
	day?: string;
}

export class HistoryApiService {
	private baseUrl = '/api/changelogs/history';

	async loadHistory(params: { user?: string; id?: string; day?: string; model?: string }): Promise<ApiHistoryResponse> {
		const payload: HistoryPayload = {
			model: 'Duty',
		};

		if (params.id) {
			payload.model = 'Duty';
			payload.id = params.id;
		} else if (params.user && params.day) {
			payload.model = 'Duty';
			payload.user = params.user;
			payload.day = params.day;
		} else if (params.model) {
			payload.model = params.model;
		}

		const response = await axios.post<ApiHistoryResponse>(this.baseUrl, payload);
		return response.data;
	}
}
